import { render } from "./Header.vue?vue&type=template&id=3089e6da&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=3089e6da&lang=css"
import "./Header.vue?vue&type=style&index=1&id=3089e6da&scoped=scoped&lang=css"

import exportComponent from "E:\\WorkCode\\HZYNew\\Code\\HZY.Student\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3089e6da"]])

export default __exports__